export default __webpack_public_path__ + "sac_fale.png";